import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Alert from 'react-bootstrap/Alert';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaDownload } from "react-icons/fa6";
import DataTable from 'react-data-table-component';
import uploadRuleSetJson from '../../../json-data/uploadruleset.json';
import UploadRuleConfirmation from './Modal-Dialog/upload-ruleconfirmation';
import ErrorRuleConfirmation from './Modal-Dialog/Error-ruleconfirmation';
import { configData } from "../../../config/systemconfigurationconstants";
import UseLambdaInvocations from '../../../hooks/useLambdaInvocations';
import * as AWS from 'aws-sdk';
import lambdaConfig from '../../../hooks/lambdaConfig';
import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import Approve from '../RuleSetManagement/Modal-Dialog/approve';
import axios from 'axios';
import Errorpopup from './Modal-Dialog/errorpopup';


const RpmTable = ({ rpmTableValues, ruleFileName, currentRpmFileName, ruleType, configjson, applyImmediately, startDate, endDate, file, enableloader, disableloader, displayuploadsection }) => {
    const [dotloader, setDotLoader] = useState(false);

    const [selectedForm, setSelectedForm] = useState('all');
    const [selectedStatus, setSelectedStatus] = useState('all');
    const [searchText, setSearchText] = useState('');
    const [selectedOption, setSelectedOption] = useState('Form and Fields');
    const [showUploadRuleSet, setshowUploadRuleSet] = useState(true);
    const [uploadrulesheet, setUploadRuleSheet] = useState(false);
    const [showRuleUploadErrorPopup, setShowRuleUploadErrorPopup] = useState(false);
    // Approve Popup
    const [approvePopup, setApprovePopup] = useState(false);
    const closeApprovePopup = () => setApprovePopup(false);
    const showApprovePopup = () => setApprovePopup(true);
    // Approve Popup
    //error popup
    const [errorPopup, setErrorPopup] = useState(false);
    const closeerrorPopup = () => setErrorPopup(false);
    const showerrorPopup = () => setErrorPopup(true);
    const [errorData, setErrorData] = useState();
    // error Popup
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    const statusMap = rpmTableValues.StatusComments[0];
    const closeUploadRuleSheet = () => setUploadRuleSheet(false);
    const showUploadRuleSheet = () => setUploadRuleSheet(true);
    const formsandFields = rpmTableValues.DiffFormFields.sort((a, b) => Number(a.FS) - Number(b.FS));
    const rpm = rpmTableValues.Diff.sort((a, b) => Number(a.FS) - Number(b.FS));;
    const form = rpmTableValues.DiffForms.sort((a, b) => Number(a.FS) - Number(b.FS));;
    const columns = [
        {
            name: 'Field Display Name',
            selector: row => row.FN,
            sortable: true,
        },
        {
            name: 'Form Short Name',
            selector: row => row.FSN,
            sortable: true,
        },
        {
            name: 'Field Short Name',
            selector: row => row.FISN,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => statusMap[row.FS] || 'Unknown',
            sortable: true,
        },
    ];

    const rpmcolumns = [

        {
            name: 'Rule Name',
            selector: row => row.R,
            sortable: true,
        },
        {
            name: 'Attribute',
            selector: row => row.A,
            sortable: true,
        },
        {
            name: 'Form Short Name',
            selector: row => row.FSN,
            sortable: true,
        },
        {
            name: 'Field Display Name',
            selector: row => row.FIN,
            sortable: true,
        },
        {
            name: 'Field Short Name',
            selector: row => row.FISN,
            sortable: true,
        },

        {
            name: 'Status',
            selector: row => statusMap[row.FS] || 'Unknown',
            sortable: true,
        },
    ];
    const formcolumns = [

        {
            name: 'Form Short Name',
            selector: row => row.FSN,
            sortable: true
        },
        {
            name: 'Status',
            selector: row => statusMap[row.FS] || 'Unknown',
            sortable: true
        }
    ];
    const conditionalRowStyles = [
        {
            when: row => statusMap[row.FS] === "MISSING in New version",
            style: {
                backgroundColor: '#f8d7da !important',
                color: '#000 !important'
            },
        },
        {
            when: row => statusMap[row.FS] === "ADDED in New version",
            style: {
                backgroundColor: '#fff3cd !important',
                color: '#000 !important'
            },
        },
        {
            when: row => statusMap[row.FS] === "No Change",
            // style: {
            //     backgroundColor: '#ffffff !important',
            // },
        },
    ];
    const handleRadioChange = (e) => {
        setSelectedOption(e.target.value);
    };
    const getCurrentColumns = () => {
        if (selectedOption === 'Form and Fields') return columns;
        if (selectedOption === 'RPM') return rpmcolumns;
        if (selectedOption === 'Form') return formcolumns;
    };

    const getCurrentData = () => {
        if (selectedOption === 'Form and Fields') return formsandFields;
        if (selectedOption === 'RPM') return rpm;
        if (selectedOption === 'Form') return form;
    };
    const [commandsName, setCommandsName] = useState([]);
    useEffect(() => {
        const commandArray = Object.entries(statusMap).map(([key, value]) => ({
            cmdname: value,
            cmdid: key
        }));
        setCommandsName(commandArray);
    }, [])
    const handleFormChange = (e) => {
        setSelectedForm(e.target.value);
    };

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value.toLowerCase());
    };
    const getFilteredData = () => {
        let data = getCurrentData();

        if (selectedForm !== 'all') {
            data = data.filter(item => item.FN === selectedForm || item.FSN === selectedForm);
        }

        if (selectedStatus !== 'all') {
            data = data.filter(item => statusMap[item.FS] === selectedStatus);
        }

        if (searchText.trim() !== '') {
            const searchLower = searchText.toLowerCase();
            data = data.filter(item => {
                const values = Object.values(item).map(val => String(val).toLowerCase());
                const status = statusMap[item.FS]?.toLowerCase() || '';

                return values.some(val => val.includes(searchLower)) || status.includes(searchLower);
            });
        }

        return data;
    };
    const getStatus = (value) => statusMap[value] || "Unknown";
    const jsonData = rpm.map(item => ({
        ...item,
        "Form Status": getStatus(item.FS),
        "Field Status": getStatus(item.FiS)
    }));
    const headers = [
        { label: "Rule Name", key: "R" },
        { label: "Attribute", key: "A" },
        { label: "Form Name", key: "FN" },
        { label: "Form Short Name", key: "FSN" },
        { label: "Field Name", key: "FIN" },
        { label: "Field Short Name", key: "FISN" },
        { label: "Form Status ID", key: "FS" },
        { label: "Form Status", key: "Form Status" },
        { label: "Field Status ID", key: "FiS" },
        { label: "Field Status", key: "Field Status" }
    ];
    const displayErrorPopup = () => {
        setShowRuleUploadErrorPopup(true)
    }
    // Helper to pad numbers
    const padZero = (num) => String(num).padStart(2, '0');

    // Create timestamp
    const now = new Date();
    const fileDate = `${padZero(now.getMonth() + 1)}-${padZero(now.getDate())}-${now.getFullYear()}`;
    const fileTime = `${padZero(now.getHours())}_${padZero(now.getMinutes())}_${padZero(now.getSeconds())}`; // use dashes instead of colons for filename safety

    const dynamicFileName = `RuleSheet_Comparison_${fileDate}_${fileTime}.csv`;
    const checkIsNewDataAddedInRS = () => {
        const checkIsMasterDataNodeAvl = rpmTableValues?.NewMasterData;

        // const hasAnyData = checkIsMasterDataNodeAvl && (Array.isArray(checkIsMasterDataNodeAvl.Docs) && checkIsMasterDataNodeAvl.Docs.length > 0 || Array.isArray(checkIsMasterDataNodeAvl.Forms) && checkIsMasterDataNodeAvl.Forms.length > 0 || Array.isArray(checkIsMasterDataNodeAvl.Fields) && checkIsMasterDataNodeAvl.Fields.length > 0);
        const hasAnyData = checkIsMasterDataNodeAvl && Object.keys(checkIsMasterDataNodeAvl).some(key =>
            key !== "Errors" &&
            Array.isArray(checkIsMasterDataNodeAvl[key]) &&
            checkIsMasterDataNodeAvl[key].length > 0
        );
        // const hasErrors = checkIsMasterDataNodeAvl && Array.isArray(checkIsMasterDataNodeAvl.Errors?.Fields) && checkIsMasterDataNodeAvl.Errors.Fields.length > 0;
        const hasErrors = checkIsMasterDataNodeAvl?.Errors &&
            Object.keys(checkIsMasterDataNodeAvl.Errors).some(key =>
                key !== "Header" &&
                Array.isArray(checkIsMasterDataNodeAvl.Errors[key]) &&
                checkIsMasterDataNodeAvl.Errors[key].length > 0
            );
        if (hasAnyData && !hasErrors) {
            console.log("NewMasterData is valid and has data");
            showApprovePopup();
        } else if (!hasAnyData) {
            showUploadRuleSheet();
            console.log("NewMasterData is missing or empty");
        } else {
            setErrorData(checkIsMasterDataNodeAvl.Errors)
            showerrorPopup();
            console.log("NewMasterData contains errors; not saving");
        }
    }
    // New Inovation Added For Save NewForms and Fields for new rule 
    const invokeCallMasterDataSave = async () => {
        setDotLoader(true)
        let datas = [rpmTableValues?.NewMasterData]
        const cleanedData = datas.map(({ Errors, ...rest }) => ({
            ...rest
        }));

        console.log(cleanedData);
        const data = {
            "Command": "MasterDataSave",
            CSN: configjson.IDXCSN,
            UCSN: configjson.IDXUCSN,
            "UserName": localStorage.getItem("UserName").trim(),
            "Environment": configData.INSTANCE,
            "NewMasterData": cleanedData
        };
        console.log(data, "NewMasterData")
        try {
            // Make the POST request with async/await
            const responseFunctionurl = await axios.post(configData.MasterSyncFunction_url, data, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Response:", responseFunctionurl.data);
            const parsedBody = responseFunctionurl.data;
            let response = parsedBody;
            console.log("login response", response);
            if (response.Status === true) {
                setDotLoader(false)
                closeApprovePopup();
                toast.success('New Master Data Added successfully', {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                showUploadRuleSheet();
            }
            else if (response.Status === false) {
                setDotLoader(false)
                closeApprovePopup();
                toast.error('New Master Data Added Failed', {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }

        } catch (err) {
            setDotLoader(false)
            closeApprovePopup();
            toast.error('New Master Data Added Failed', {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            console.error("Error submitting form:", err);
        } finally {
            setDotLoader(false)
        }
    }
    return (<>
        <Col sm={12}>
            <Row>
                <Col sm={3} className='pe-0'>
                    <Alert variant="primary" className='d-flex justify-content-center'>
                        <Form>
                            <Form.Check
                                inline
                                label="Form and Fields"
                                type="radio"
                                value="Form and Fields"
                                checked={selectedOption === 'Form and Fields'}
                                onChange={handleRadioChange}
                            />
                            <Form.Check
                                inline
                                label="RPM"
                                type="radio"
                                value="RPM"
                                checked={selectedOption === 'RPM'}
                                onChange={handleRadioChange}
                            />
                            <Form.Check
                                inline
                                label="Form"
                                type="radio"
                                value="Form"
                                checked={selectedOption === 'Form'}
                                onChange={handleRadioChange}
                            />
                        </Form>
                    </Alert>
                </Col>
                <Col sm={7}></Col>
                <Col sm={2} className='text-end'>

                    {/* <FaDownload className='bounce-icon' /> Download */}
                    <CSVLink
                        data={jsonData}
                        headers={headers}
                        filename={dynamicFileName}
                        className="btn btn-outline-success btn-sm"
                        target="_blank"
                    >
                        <FaDownload className='bounce-icon' /> Download
                    </CSVLink>

                </Col>
            </Row>

            <Row>
                <Col sm={12}>
                    <div className="d-flex justify-content-between mb-2">
                        <div>
                            <Form.Select size="sm" onChange={handleFormChange}>
                                <option disabled>Select Forms</option>
                                <option value="all">All</option>
                                {form.map((item, index) => (
                                    <option key={index} value={item.FN}>{item.FN}</option>
                                ))}
                            </Form.Select>
                        </div>
                        <div>
                            <Row className='mb-1'>
                                <Col className='pe-0'>
                                    <Form.Select size="sm" onChange={handleStatusChange}>
                                        <option disabled>Filter by Status</option>
                                        <option value="all">All</option>
                                        {commandsName.map((item, index) => (
                                            <option key={index} value={item.cmdname}>{item.cmdname}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Control size="sm" type="text" placeholder="Search" onChange={handleSearchChange} />
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <DataTable
                        columns={getCurrentColumns()}
                        data={getFilteredData()}
                        pagination
                        dense
                        conditionalRowStyles={conditionalRowStyles}
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30]}
                    />

                    <Row>
                        <Col sm={12} className='text-end mt-1'>
                            <Button variant="secondary" size='sm' className='me-1' onClick={displayuploadsection}>Cancel</Button>
                            {/* <Button variant="primary" size='sm' onClick={showUploadRuleSheet}>Go</Button> */}
                            <Button variant="primary" size='sm' onClick={checkIsNewDataAddedInRS}>Go</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Approve show={approvePopup} handleClose={closeApprovePopup} invokeCallMasterDataSave={invokeCallMasterDataSave} dotloader={dotloader} />
            <Errorpopup show={errorPopup} handleClose={closeerrorPopup} errorData={errorData} />
            <UploadRuleConfirmation show={uploadrulesheet} handleClose={closeUploadRuleSheet} ruleFileName={ruleFileName} currentRpmFileName={currentRpmFileName} ruleType={ruleType} showUploadRuleSheet={showUploadRuleSheet} configjson={configjson} applyImmediately={applyImmediately} startDate={startDate} endDate={endDate} file={file} enableloader={enableloader} disableloader={disableloader} displayuploadsection={displayuploadsection} displayErrorPopup={displayErrorPopup} />
            <ErrorRuleConfirmation showerrorruleconfirmpopup={showRuleUploadErrorPopup} />
        </Col>

        {/* <UploadRuleConfirmation show={uploadrulesheet} handleClose={closeUploadRuleSheet} /> */}

    </>)
}
export default RpmTable;